import { set } from 'date-fns/set';

type DatePartInput = number | string | null | undefined;

const normalisePart = (value: DatePartInput): number | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value === 'string') {
    return Number(value);
  }

  return value;
};

const customSet = (
  year: DatePartInput,
  month: DatePartInput,
  date: DatePartInput = 1,
  hours: DatePartInput = 0,
  minutes: DatePartInput = 0,
  seconds: DatePartInput = 0,
  milliseconds: DatePartInput = 0,
): Date =>
  set(new Date(), {
    year: normalisePart(year),
    month: normalisePart(month),
    date: normalisePart(date),
    hours: normalisePart(hours),
    minutes: normalisePart(minutes),
    seconds: normalisePart(seconds),
    milliseconds: normalisePart(milliseconds),
  });

export default customSet;
